


// ============================================================
// 4. src/plugins/globalErrorHandler.js (수정본)
// ============================================================

import { logError, report } from '@/utils/logHelper';
import { extractErrorMessage } from '@/utils/errorUtils';  // ✅ 공통 유틸 사용

const MODE = process.env.NODE_ENV || 'development';
const IS_DEV = MODE === 'development';

// ✅ HTTP 상태에 따른 토스트 표시
function showToast(toast, msg, status) {
  if (!toast) {
    if (IS_DEV) console.warn('[globalErrorHandler] Toast not available');
    return;
  }

  if (status && status >= 400 && status < 500) {
    toast.warning(msg);
  } else {
    toast.error(msg);
  }
}

const REJECTION_FLAG = '__mpnite_unhandledrejection__';

export default {
  install(app) {
    // 1. 컴포넌트용 API 에러 핸들러
    app.config.globalProperties.$handleApiError = function (
      error,
      defaultMessage = '오류가 발생했습니다.'
    ) {
      const status = error?.response?.status;
      const msg = extractErrorMessage(error) || defaultMessage;
      const toast = this?.$toast || app.config.globalProperties.$toast;

      showToast(toast, msg, status);
      logError('API Error', { status, message: msg, error });

      if (!IS_DEV) report(error, { status, message: msg });
    };

    // 2. Vue 전역 에러 핸들러
    app.config.errorHandler = (err, instance, info) => {
      const componentName = instance?.$options?.name
        || instance?.$?.type?.name
        || 'Anonymous';

      const msg = extractErrorMessage(err) || '에러가 발생했습니다.';
      const toast = app.config.globalProperties.$toast;

      logError('🔥 [Vue Error]', {
        component: componentName,
        lifecycle: info,
        message: msg,
        error: err,
        stack: err?.stack
      });

      if (!IS_DEV) {
        report(err, { component: componentName, lifecycle: info });
      }

      showToast(toast, `에러가 발생했습니다: ${msg}`);
    };

    // 3. 비동기 예외 처리
    if (typeof window !== 'undefined' && !window[REJECTION_FLAG]) {
      window[REJECTION_FLAG] = true;

      window.addEventListener('unhandledrejection', (event) => {
        const reason = event?.reason;
        const status = reason?.response?.status;
        const msg = extractErrorMessage(reason) || '비동기 오류가 발생했습니다.';
        const toast = app.config.globalProperties.$toast;

        logError('🔥 [Unhandled Rejection]', { status, message: msg, reason });

        if (!IS_DEV) {
          report(reason instanceof Error ? reason : new Error(msg));
        }

        showToast(toast, `비동기 오류: ${msg}`, status);
      });
    }
  }
};